import React from "react";
import { Switch } from "@/components/ui/switch";
import { Input } from "@/components/ui/input";

const euros = (v) => Number(v).toLocaleString("fr-FR");
export const SkodaConditionsPanel = ({ model, form, onChange }) => {
  const plan = model.skoda_conditions;
  const company = form.company_type !== "NON";
  const rate = model.company_rates?.[form.company_type];
  const recommended = plan.recommended_discounts?.[form.company_type];
  const hasVD = form.is_vd_sale || form.is_vdr_sale;
  const eligible = !company && plan.renewal_aid_ht > 0 && (hasVD || form.sale_type === "STOCK");
  const request = form.skoda_renewal;
  const update = (key, value) => onChange("skoda_renewal", { ...request, [key]: value });
  return (
    <section data-testid="skoda-conditions-panel" className="mt-4 border-t border-emerald-200 pt-4 space-y-3">
      <div className="flex flex-wrap justify-between gap-2 text-sm font-medium">
        <span data-testid="skoda-conditions-title">Škoda · {plan.period}</span>
        {company && rate !== undefined && <span data-testid="skoda-total-company-rate">Marge totale : {euros(rate * 100)} %</span>}
      </div>
      {company ? (
        <p data-testid="skoda-company-rule" className="text-sm text-muted-foreground">
          {form.company_type === "PSTE_RY" ? "Taux total sur accord WEFLEET, base incluse." : rate === undefined ? "Catégorie non renseignée pour ce modèle." :
            `Base incluse, sans cumul.${recommended !== undefined ? ` Remise préconisée : ${euros(recommended * 100)} %.` : ""}`}
        </p>
      ) : <p data-testid="skoda-private-rule" className="text-sm text-muted-foreground">
        {hasVD ? `Marge de base + ${form.is_vd_sale ? "VD" : "VDP"} ; aide à la vente particuliers non cumulée.` :
          plan.private_grid_verified ? `Offre client de référence : ${euros(plan.private_offer_ttc)} € TTC · Participation réseau : ${euros(plan.network_participation_ht)} € HT.` : "Finition absente de la nouvelle grille particuliers : conditions antérieures conservées."}
      </p>}
      {!company && plan.renewal_aid_ht > 0 && <>
        <div className="flex items-center justify-between gap-3 border-t pt-3">
          <label htmlFor="skoda-renewal-enable" data-testid="skoda-renewal-label" className="text-sm font-medium">Renouvellement Škoda · +{euros(plan.renewal_aid_ht)} € HT</label>
          <Switch id="skoda-renewal-enable" data-testid="skoda-renewal-switch" disabled={!eligible} checked={!!request && eligible}
            onCheckedChange={(enabled) => onChange("skoda_renewal", enabled ? { skoda_trade_in_confirmed: false, ren_documentation_confirmed: false, is_deal: false, order_date: "", registration_date: "" } : null)} />
        </div>
        <p data-testid="skoda-renewal-eligibility" className="text-xs text-muted-foreground">Thermique en stock ou VD/VDP, particuliers hors DEAL. PO du 01/10 au 31/12/2026 ; immatriculation au plus tard le 31/12/2026. Cumulable avec les aides existantes.</p>
        {request && eligible && <div className="space-y-3">
          {[
            ["skoda_trade_in_confirmed", "Reprise d’une Škoda confirmée"],
            ["ren_documentation_confirmed", "Bon de commande et carte grise conformes / code REN confirmé"],
            ["is_deal", "Vente via DEAL (non éligible)"],
          ].map(([key, label]) => <div key={key} className="flex items-center justify-between gap-3">
            <label htmlFor={`skoda-${key}`} data-testid={`skoda-${key.replaceAll("_", "-")}-label`} className="text-sm">{label}</label>
            <Switch id={`skoda-${key}`} data-testid={`skoda-${key.replaceAll("_", "-")}-switch`} checked={request[key]} onCheckedChange={(value) => update(key, value)} />
          </div>)}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {[["order_date", "Date de commande"], ["registration_date", "Date d’immatriculation"]].map(([key, label]) => <div key={key} className="min-w-0 space-y-1">
              <label htmlFor={`skoda-${key}`} data-testid={`skoda-${key.replaceAll("_", "-")}-label`} className="text-sm">{label}</label>
              <Input id={`skoda-${key}`} data-testid={`skoda-${key.replaceAll("_", "-")}-input`} type="date" className="min-w-0 max-w-full" value={request[key] || ""}
                min={key === "order_date" ? plan.renewal_order_from : undefined} max="2026-12-31" onChange={(event) => update(key, event.target.value)} />
            </div>)}
          </div>
        </div>}
      </>}
    </section>
  );
};